import { Theme } from './types'

const darkTheme: Theme = {
  base: '#222326',
  surface: '#27292D',
  text: 'rgba(255, 255, 255, 0.8)'
}

export default darkTheme
